var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.933594,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#7EA1C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1406 25.9336V15.4219H10.8711V25.9336H14.1406ZM12.4883 14.0156C13.543 14.0156 14.3867 13.1367 14.3867 12.082C14.3867 11.0625 13.543 10.2188 12.4883 10.2188C11.4688 10.2188 10.625 11.0625 10.625 12.082C10.625 13.1367 11.4688 14.0156 12.4883 14.0156ZM26.3398 25.9336H26.375V20.168C26.375 17.3555 25.7422 15.1758 22.4375 15.1758C20.8555 15.1758 19.8008 16.0547 19.3438 16.8633H19.3086V15.4219H16.1797V25.9336H19.4492V20.7305C19.4492 19.3594 19.6953 18.0586 21.3828 18.0586C23.0703 18.0586 23.1055 19.6055 23.1055 20.8359V25.9336H26.3398Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndeed);
export default __webpack_public_path__ + "static/media/indeed.6f815b796f9d1bfc4592ca8232d223cb.svg";
export { ForwardRef as ReactComponent };